import PropTypes from "prop-types";
import * as Yup from "yup";
// form
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
// @mui
import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";
// hooks
import useIsMountedRef from "../../../hooks/useIsMountedRef";
// components
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import Translate from "src/components/translate";
import { FormProvider, RHFTextField } from "../../../components/hook-form";

// ----------------------------------------------------------------------

ResetPasswordForm.propTypes = {
  onSent: PropTypes.func,
  onGetEmail: PropTypes.func,
};

export default function ResetPasswordForm({ onSent, validationError }) {
  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar } = useSnackbar();

  const ResetPasswordSchema = Yup.object().shape({
    mobile: Yup.string().required("Mobile is required"),
  });

  const methods = useForm({
    resolver: yupResolver(ResetPasswordSchema),
  });

  const {
    handleSubmit,
    setError,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    if (isMountedRef.current) await onSent(data.mobile);
  };
  useEffect(() => {
    if (Boolean(validationError)) {
      setError("mobile", { message: validationError });
    }
  }, [validationError]);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <RHFTextField name="mobile" label="Mobile" />
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          name="ResetPassword">
          <Translate>register.reset</Translate>
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
